export const parseStringToInt = (wordToNumber: string, radix = 10) => {
  const parsedValue = parseInt(wordToNumber, radix);

  if (Number.isNaN(parsedValue)) {
    throw new Error('Incorrect string value provided');
  }

  return parsedValue;
};
